import { useBoundContext } from "lib/@components/binding/use-bound-context"
import { StandardCheckBox } from "lib/@components/standard-checkbox"
import { ExtendedSelectBefore } from "slot-definitions"
import { Box } from "@mui/material"

export function CreateUniqueValueEditor() {
    const { item } = useBoundContext()
    if (!item.unique) {
        return "No Options"
    }

    return (
        <>
            <ExtendedSelectBefore.Plug type={item.field}>
                <Box width={28}>
                    <CheckedItem />
                </Box>
            </ExtendedSelectBefore.Plug>
            Create Unique Value
        </>
    )
}

function CheckedItem() {
    const { mapping, setMapping } = useBoundContext()
    const value = mapping === "*UNIQUE"
    return (
        <StandardCheckBox aria-label="Create unique value for each row" labelRight value={value} onChange={setValue} />
    )
    function setValue(e) {
        if (e.target.value) {
            setMapping("*UNIQUE")
        } else {
            setMapping(undefined)
        }
    }
}
